import { FC } from 'react';
import { TActionSpeedDialProps } from './types';

export const ActionSpeedDial: FC<TActionSpeedDialProps> = ({
	sortable,
	onChangeSort,
	sortDirection,
}) => {
	const handleSort = () => {
		if (!sortable) return;
		if (sortDirection === 'asc') {
			onChangeSort?.('desc');
		} else if (sortDirection === 'desc') {
			onChangeSort?.('asc');
		} else {
			onChangeSort?.('asc');
		}
	};

	return (
		<div
			style={{ position: 'absolute', right: '0', top: '0', width: '100%', height: '100%' }}
			className="action-speed-dial"
			onClick={handleSort}
		/>
	);
};
